import React from "react";
import "./Pill.css";

export interface PillProps {
  className?: string;
  children: React.ReactNode;
}

const Pill: React.FC<PillProps> = ({ className, children }) => {
  const baseClass = "ui-pill";
  const classes = className ? `${baseClass} ${className}` : baseClass;

  return <span className={classes}>{children}</span>;
};

export default Pill;

